import { render, staticRenderFns } from "./resetPasswordRequest_page.vue?vue&type=template&id=23ddc442&scoped=true&"
import script from "./resetPasswordRequest_page.vue?vue&type=script&lang=js&"
export * from "./resetPasswordRequest_page.vue?vue&type=script&lang=js&"
import style0 from "./resetPasswordRequest_page.vue?vue&type=style&index=0&id=23ddc442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ddc442",
  null
  
)

export default component.exports